"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _filterRubric = _interopRequireDefault(require("./filter-rubric"));

var _scrollBox = _interopRequireDefault(require("../../scroll-box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var FilterSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterSelect, _React$Component);

  function FilterSelect(props) {
    var _this;

    _classCallCheck(this, FilterSelect);

    _this = _possibleConstructorReturn(this, (FilterSelect.__proto__ || Object.getPrototypeOf(FilterSelect)).call(this, props));
    _this.state = {
      selectedRubricId: null,
      showFilterRubric: true,
      filteredProducts: []
    };
    _this.onCloseFilterClick = _this.onCloseFilterClick.bind(_assertThisInitialized(_this));
    _this.onResetFilterClick = _this.onResetFilterClick.bind(_assertThisInitialized(_this));
    _this.onItemClick = _this.onItemClick.bind(_assertThisInitialized(_this));
    _this.onRubricClick = _this.onRubricClick.bind(_assertThisInitialized(_this));
    _this.onButtonClick = _this.onButtonClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.selectedRubricId !== prevState.selectedRubricId) {
        this.filterProductsForSelectedRubric();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          t = _this$props.t,
          product = _this$props.product,
          products = _this$props.products;
      var resetReady = false;
      var showResultNumber = false;

      if (parseInt(this.props.numbersOfResults)) {
        showResultNumber = true;
      }

      var renderedProducts = this.state.selectedRubricId ? this.renderProductsForSelectedRubric() : null;
      product && product.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.props.items.map(function (item) {
        if (_this2.props.selectedItems.map(function (i) {
          return i.id;
        }).indexOf(item.id) >= 0) {
          resetReady = true;
        }
      });
      if (!this.props.visible) return null;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'filter-select'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'filter-header'
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: 'close-filter-detail-selection',
        onClick: this.onCloseFilterClick
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: 'filter-name'
      }, t(this.props.name)), /*#__PURE__*/_react.default.createElement("a", {
        href: 'javascript:void(0)',
        className: "filter-reset-link ".concat(resetReady ? 'ready' : ''),
        onClick: this.onResetFilterClick
      }, t('Zurücksetzen'))), /*#__PURE__*/_react.default.createElement(_scrollBox.default, null, /*#__PURE__*/_react.default.createElement("ul", {
        className: 'filter-menu'
      }, this.props.items && this.props.items.sort(function (a, b) {
        // If parameterName is rubric, sort by id
        // if (a.parameterName === 'products' && b.parameterName === 'products') {
        //     return parseInt(a.id) - parseInt(b.id);
        // }
        // Otherwise, sort alphabetically by name
        return a.name.localeCompare(b.name);
      }).map(function (item, index) {
        var isItemInProducts = product && product.some(function (product) {
          return product.rubric_id === parseInt(item.id);
        });

        if (isItemInProducts && item.parameterName === 'products' && _this2.state.showFilterRubric) {
          return /*#__PURE__*/_react.default.createElement(_filterRubric.default, {
            t: t,
            rubric: products,
            product: product,
            key: item.id,
            item: item,
            showTitle: index === 0,
            onRubricClick: function onRubricClick() {
              return _this2.onRubricClick(item.id);
            }
          });
        }

        if (!isItemInProducts && item.parameterName === 'products') {
          return null;
        }

        if (_this2.state.selectedRubricId === null) {
          return /*#__PURE__*/_react.default.createElement(_checkbox.default, {
            key: item.id,
            t: t,
            selectedItems: _this2.props.selectedItems,
            selectedFilters: _this2.props.selectedFilters,
            item: item,
            onItemClick: _this2.onItemClick,
            disabled: false
          });
        }
      }), this.props.stringItems && this.props.stringItems.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          key: item.id,
          t: t,
          selectedItems: _this2.props.selectedItems,
          selectedFilters: _this2.props.selectedFilters,
          item: item,
          onItemClick: _this2.onItemClick,
          disabled: false
        });
      }), renderedProducts)), /*#__PURE__*/_react.default.createElement("button", {
        className: "summary-button ".concat(this.props.selectedItems.length > 0 ? 'ready' : ''),
        onClick: this.onButtonClick
      }, !showResultNumber && t('Übernehmen'), showResultNumber && t('search-result', {
        count: parseInt(this.props.numbersOfResults)
      }))));
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(selectedItem) {
      this.props.onItemClick(selectedItem);
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick() {
      this.onRubricClick(null);
      this.props.onShowResultsClick();
    }
  }, {
    key: "onRubricClick",
    value: function onRubricClick(rubricId) {
      this.setState(function (prevState) {
        return {
          selectedRubricId: prevState.selectedRubricId === rubricId ? null : rubricId
        };
      }); // Toggle the FilterRubric visibility

      this.setState(function (prevState) {
        return {
          showFilterRubric: !prevState.showFilterRubric
        };
      });
    }
  }, {
    key: "filterProductsForSelectedRubric",
    value: function filterProductsForSelectedRubric() {
      var product = this.props.product;
      var selectedRubricId = this.state.selectedRubricId;
      var mappedProducts = (product || []).map(function (p) {
        return {
          id: p.id ? p.id : null,
          name: p.name ? p.name : null,
          value: p.name ? p.name : null,
          rubric_id: p.rubric_id ? p.rubric_id : null,
          parameterName: 'products'
        };
      });
      var filteredProducts = mappedProducts.filter(function (product) {
        return parseInt(product.rubric_id) === parseInt(selectedRubricId);
      });
      this.setState({
        filteredProducts: filteredProducts
      });
    }
  }, {
    key: "renderProductsForSelectedRubric",
    value: function renderProductsForSelectedRubric() {
      var _this3 = this;

      var _this$props2 = this.props,
          t = _this$props2.t,
          products = _this$props2.products,
          offersAvailability = _this$props2.offersAvailability; // Added offersAvailability here

      var _this$state = this.state,
          selectedRubricId = _this$state.selectedRubricId,
          filteredProducts = _this$state.filteredProducts;
      var noResults = this.props.numbersOfResults === 0;

      if (filteredProducts.length === 0) {
        return null;
      }

      var matchingRubric = products.find(function (r) {
        return r.id === selectedRubricId;
      });
      var rubricName = matchingRubric.name;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("strong", {
        className: "filter-menu-item filter-menu-item-title"
      }, rubricName), /*#__PURE__*/_react.default.createElement("div", {
        className: 'product-filter'
      }, filteredProducts.map(function (productItem) {
        var isAvailable = offersAvailability.some(function (offer) {
          return offer.name === productItem.name;
        }) || _this3.props.selectedItems.some(function (offer) {
          return offer.value === productItem.name;
        });

        if (!parseInt(noResults) && noResults && !isAvailable) {
          return /*#__PURE__*/_react.default.createElement(_checkbox.default, {
            key: productItem.id,
            t: t,
            selectedItems: _this3.props.selectedItems,
            selectedFilters: _this3.props.selectedFilters,
            item: productItem,
            disabled: true,
            onItemClick: _this3.onItemClick
          });
        }

        return /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          key: productItem.id,
          t: t,
          selectedItems: _this3.props.selectedItems,
          selectedFilters: _this3.props.selectedFilters,
          item: productItem,
          onItemClick: _this3.onItemClick,
          disabled: parseInt(_this3.props.numbersOfResults) && !isAvailable
        });
      })));
    }
  }, {
    key: "onCloseFilterClick",
    value: function onCloseFilterClick(e) {
      e.preventDefault(); // close product filter

      if (!this.state.showFilterRubric) {
        return this.onRubricClick(null);
      }

      return this.props.onCloseFilterClick();
    }
  }, {
    key: "onResetFilterClick",
    value: function onResetFilterClick() {
      this.props.onResetFilterClick();
    }
  }]);

  return FilterSelect;
}(_react.default.Component);

FilterSelect.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired
  })),
  stringItems: _propTypes.default.array,
  selectedItems: _propTypes.default.array,
  rubric: _propTypes.default.array,
  products: _propTypes.default.array,
  product: _propTypes.default.array,
  selectedFilters: _propTypes.default.object,
  onCloseFilterClick: _propTypes.default.func,
  onResetFilterClick: _propTypes.default.func,
  onItemClick: _propTypes.default.func,
  onShowResultsClick: _propTypes.default.func,
  visible: _propTypes.default.bool,
  name: _propTypes.default.string,
  offersAvailability: _propTypes.default.array,
  numbersOfResults: _propTypes.default.number
};
var _default = FilterSelect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-filter/lib/filter-select.js
// module id = 875
// module chunks = 0